// extracted by mini-css-extract-plugin
var _1 = "BypUG";
var _2 = "_ybNL";
var _3 = "Pga5o";
var _4 = "eqaOw";
var _5 = "QAQPf";
var _6 = "XWj4y";
var _7 = "C7Hc5";
var _8 = "N3_bX";
var _9 = "XouY9";
export { _1 as "isShyHeaderMode", _2 as "overlayLeftPane", _3 as "overlayLeftPaneBelowRibbon", _4 as "overlayLeftPaneBelowRibbonWin32Overlay", _5 as "overlayLeftPaneMain", _6 as "overlayLeftPaneScrollableContent", _7 as "overlayLeftPaneScrollableContentNoScroll", _8 as "overlayLeftPaneWin32", _9 as "overlayLeftPaneWithAppNames" }
